var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dadosCadastros !== undefined
    ? _c(
        "div",
        { staticClass: "analise" },
        [
          _c(
            "el-card",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c(
                "el-col",
                { staticClass: "center", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Nome do Interessado:",
                      content: _vm.processo.nomeRazaoSocialInteressado
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Número do processo:",
                      content: _vm.processo.numeroProcesso
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "CPF do Interessado:",
                      content: _vm.processo.cpfCnpjInteressado
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Tipo de Processo:",
                      content: _vm.processo.tipo.nome
                    }
                  })
                ],
                1
              ),
              _c("app-opcoes-header-analise", {
                staticClass: "right",
                attrs: {
                  idProcesso: _vm.processo.id,
                  numeroProcesso: _vm.processo.numeroProcesso,
                  tipoProcesso: _vm.processo.tipo.codigo,
                  protocolo: _vm.processo.numeroProtocolo,
                  idDespacho: _vm.dadosCadastros.despacho.id,
                  btnSolicitarInformacao: !_vm.isBa,
                  isSubProcesso: true
                }
              })
            ],
            1
          ),
          _c(
            "validation-observer",
            { ref: "validation", attrs: { tag: "form" } },
            [
              _c(
                "el-card",
                { staticClass: "card-collapse", attrs: { shadow: "hover" } },
                [
                  _c("app-despachos", {
                    attrs: {
                      idProcesso: _vm.idProcesso,
                      data: _vm.dadosCadastros.setores
                    },
                    on: {
                      getDownload: _vm.getDownload,
                      getAnotacao: _vm.getAnotacao
                    }
                  })
                ],
                1
              ),
              _vm.dadosCadastros && _vm.showInfoTecnicoDeCampo
                ? _c(
                    "el-card",
                    {
                      staticClass: "card-collapse",
                      attrs: { shadow: "hover" }
                    },
                    [
                      _vm.visualizarBotoes
                        ? _c(
                            "div",
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "container-buttons"
                                            },
                                            [
                                              _c(
                                                "el-radio-group",
                                                {
                                                  attrs: { name: "parecer" },
                                                  model: {
                                                    value: _vm.despacho,
                                                    callback: function($$v) {
                                                      _vm.despacho = $$v
                                                    },
                                                    expression: "despacho"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "padding input",
                                                      class: {
                                                        erro: errors.length
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: {
                                                            label: false,
                                                            border: true
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Documentos georreferenciamento"
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: {
                                                            label: true,
                                                            border: true
                                                          }
                                                        },
                                                        [_vm._v("Despacho")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  4086037607
                                )
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.despacho && _vm.showModalDespacho
                        ? _c(
                            "div",
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("p", { staticClass: "label" }, [
                                            _vm._v("Despacho")
                                          ]),
                                          _c("app-editor-texto", {
                                            ref: "editorTexto",
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            on: {
                                              onTextChange: _vm.onTextChange
                                            },
                                            model: {
                                              value:
                                                _vm.dadosCadastros.despacho
                                                  .textoDespacho,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosCadastros.despacho,
                                                  "textoDespacho",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "dadosCadastros.despacho.textoDespacho"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  169179687
                                )
                              }),
                              _vm.anexos &&
                              _vm.dadosCadastros.despacho &&
                              _vm.dadosCadastros.despacho.documentos.length ===
                                0
                                ? _c("app-anexo", {
                                    attrs: {
                                      id: "upload-anexo-despacho",
                                      files: _vm.anexos,
                                      tipoExibir: "ANEXO_ANALISE"
                                    },
                                    on: {
                                      uploadFile: _vm.uploadFile,
                                      removeFile: _vm.removeFile,
                                      downloadDocumentoCadastro:
                                        _vm.downloadDocumentoCadastro
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _vm.isGeomensor() || _vm.isFiscalizador()
                                ? _c(
                                    "div",
                                    { staticClass: "margin-medium-top" },
                                    [
                                      _vm.pecasTecnicas &&
                                      _vm.pecasTecnicas.length > 0 &&
                                      !_vm.isRo
                                        ? _c("app-divider", {
                                            staticClass: "margin-top-bottom",
                                            attrs: {
                                              label: "Peças Técnicas",
                                              showBorder: false
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.pecasTecnicas &&
                                      _vm.pecasTecnicas.length > 0 &&
                                      !_vm.isRo
                                        ? _c(
                                            "el-table",
                                            {
                                              staticClass: "margin-bottom",
                                              attrs: { data: _vm.pecasTecnicas }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "nome",
                                                  label: "Nome do Arquivo:"
                                                }
                                              }),
                                              _c("el-table-column", {
                                                attrs: { width: "100" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(scope) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex"
                                                            },
                                                            [
                                                              _c(
                                                                "app-action-button",
                                                                {
                                                                  attrs: {
                                                                    icone:
                                                                      "download",
                                                                    cor:
                                                                      "#666666",
                                                                    text:
                                                                      "Baixar Documento"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.getDownload(
                                                                        scope.row
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  2137845300
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      !_vm.pecasTecnicas && !_vm.isRo
                                        ? _c("p", [
                                            _vm._v(
                                              "Nenhuma peça técnica encontrada."
                                            )
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.isGeomensor() || _vm.isFiscalizador()
                                ? [
                                    _vm.showCodigoEstado && !_vm.isReurb
                                      ? _c("app-dados-gerais-os", {
                                          attrs: {
                                            numeroIterpa:
                                              _vm.dadosCadastros.despacho
                                                .numeroIterpa
                                          },
                                          on: { setCodigo: _vm.setCodigoIterpa }
                                        })
                                      : _vm._e(),
                                    _vm.showResponsavel && _vm.isGeomensor()
                                      ? _c("app-dados-responsavel", {
                                          attrs: {
                                            responsavel: _vm.responsavel,
                                            processo: _vm.processo
                                          }
                                        })
                                      : _vm._e(),
                                    _vm.isReurb
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-row",
                                              { attrs: { gutter: 30 } },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 12 } },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules:
                                                          _vm.required.rules
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "app-label",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Lote"
                                                                    }
                                                                  }
                                                                ),
                                                                _c("el-input", {
                                                                  staticClass:
                                                                    "input",
                                                                  class: {
                                                                    error:
                                                                      errors.length
                                                                  },
                                                                  attrs: {
                                                                    maxlength: 50,
                                                                    type: "text"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.loteEndereco,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.loteEndereco = $$v
                                                                    },
                                                                    expression:
                                                                      "loteEndereco"
                                                                  }
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "help erro"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        false,
                                                        3486027791
                                                      )
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 12 } },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules:
                                                          _vm.required.rules
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "app-label",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Quadra"
                                                                    }
                                                                  }
                                                                ),
                                                                _c("el-input", {
                                                                  staticClass:
                                                                    "input",
                                                                  class: {
                                                                    error:
                                                                      errors.length
                                                                  },
                                                                  attrs: {
                                                                    maxlength: 50,
                                                                    type: "text"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.quadra,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.quadra = $$v
                                                                    },
                                                                    expression:
                                                                      "quadra"
                                                                  }
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "help erro"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        false,
                                                        1544290270
                                                      )
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-row",
                                              { attrs: { gutter: 30 } },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 12 } },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules:
                                                          _vm.required.rules
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "app-label",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Rua"
                                                                    }
                                                                  }
                                                                ),
                                                                _c("el-input", {
                                                                  staticClass:
                                                                    "input",
                                                                  class: {
                                                                    error:
                                                                      errors.length
                                                                  },
                                                                  attrs: {
                                                                    maxlength: 50,
                                                                    type: "text"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.rua,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.rua = $$v
                                                                    },
                                                                    expression:
                                                                      "rua"
                                                                  }
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "help erro"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        false,
                                                        449981150
                                                      )
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 12 } },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules:
                                                          _vm.required.rules
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "app-label",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Bairro"
                                                                    }
                                                                  }
                                                                ),
                                                                _c("el-input", {
                                                                  staticClass:
                                                                    "input",
                                                                  class: {
                                                                    error:
                                                                      errors.length
                                                                  },
                                                                  attrs: {
                                                                    maxlength: 50,
                                                                    type: "text"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.bairro,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.bairro = $$v
                                                                    },
                                                                    expression:
                                                                      "bairro"
                                                                  }
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "help erro"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        false,
                                                        4117467262
                                                      )
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-row",
                                              { attrs: { gutter: 30 } },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 12 } },
                                                  [
                                                    _c("app-label", {
                                                      attrs: {
                                                        label: "Complemento",
                                                        required: false
                                                      }
                                                    }),
                                                    _c("el-input", {
                                                      staticClass: "input",
                                                      attrs: {
                                                        maxlength: 50,
                                                        type: "text"
                                                      },
                                                      model: {
                                                        value: _vm.complemento,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.complemento = $$v
                                                        },
                                                        expression:
                                                          "complemento"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 6 } },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules:
                                                          _vm.required.rules
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "app-label",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Código Imóvel"
                                                                    }
                                                                  }
                                                                ),
                                                                _c("el-input", {
                                                                  staticClass:
                                                                    "input",
                                                                  class: {
                                                                    error:
                                                                      errors.length
                                                                  },
                                                                  attrs: {
                                                                    maxlength: 50,
                                                                    type:
                                                                      "text",
                                                                    disabled: true
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.codigoImovel,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.codigoImovel = $$v
                                                                    },
                                                                    expression:
                                                                      "codigoImovel"
                                                                  }
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "help erro"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        false,
                                                        3843841774
                                                      )
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 6 } },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: !_vm.digitarCodigoArt
                                                          ? "required"
                                                          : ""
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "app-label",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Código ART/TRT:",
                                                                      required:
                                                                        _vm.digitarCodigoArt
                                                                    }
                                                                  }
                                                                ),
                                                                _c("el-input", {
                                                                  staticClass:
                                                                    "input",
                                                                  class: {
                                                                    error:
                                                                      errors.length
                                                                  },
                                                                  attrs: {
                                                                    value:
                                                                      _vm.codigoArtTrt,
                                                                    maxlength: 50,
                                                                    type:
                                                                      "text",
                                                                    disabled: !_vm.digitarCodigoArt
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.codigoArtTrt,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.codigoArtTrt = $$v
                                                                    },
                                                                    expression:
                                                                      "codigoArtTrt"
                                                                  }
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "help erro"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        false,
                                                        2499172110
                                                      )
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.isGeomensor()
                                      ? [
                                          [
                                            _vm.uploadDocumentoArt
                                              ? _c("app-label", {
                                                  staticClass: "campo",
                                                  attrs: {
                                                    label:
                                                      "Upload documento ART/TRT:",
                                                    required:
                                                      _vm.uploadDocumentoArt
                                                  }
                                                })
                                              : _vm._e(),
                                            _c("validation-provider", {
                                              attrs: {
                                                rules: _vm.uploadDocumentoArt
                                                  ? _vm.isValidate
                                                  : ""
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c("app-anexo", {
                                                          attrs: {
                                                            id: "upload-anex",
                                                            tiposArquivosPermitidos:
                                                              ".pdf",
                                                            files:
                                                              _vm.documentoArtTrtOs,
                                                            showUpload:
                                                              _vm.uploadDocumentoArt,
                                                            exibirDelete:
                                                              _vm.uploadDocumentoArt,
                                                            errors: errors
                                                          },
                                                          on: {
                                                            downloadDocumentoCadastro:
                                                              _vm.getDownload,
                                                            uploadFile:
                                                              _vm.uploadArt,
                                                            removeFile:
                                                              _vm.removeArt
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.documentoArtTrtOs,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.documentoArtTrtOs = $$v
                                                            },
                                                            expression:
                                                              "documentoArtTrtOs"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                531964874
                                              )
                                            })
                                          ]
                                        ]
                                      : _vm._e(),
                                    _vm.isGeomensor()
                                      ? _c(
                                          "div",
                                          [
                                            !_vm.isReurb &&
                                            _vm.exibirTipoAnaliseGeo
                                              ? _c("validation-provider", {
                                                  attrs: { rules: "required" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c(
                                                              "div",
                                                              {
                                                                class: {
                                                                  error:
                                                                    errors.length
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "tipo-de-analise"
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        "Tipo de análise"
                                                                      )
                                                                    ])
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "el-radio",
                                                                  {
                                                                    attrs: {
                                                                      label: true,
                                                                      border:
                                                                        "border"
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.tipoAnalisePlanilha,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.tipoAnalisePlanilha = $$v
                                                                      },
                                                                      expression:
                                                                        "tipoAnalisePlanilha"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Utilizar planilha ODS"
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "el-radio",
                                                                  {
                                                                    attrs: {
                                                                      label: false,
                                                                      border:
                                                                        "border"
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.tipoAnalisePlanilha,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.tipoAnalisePlanilha = $$v
                                                                      },
                                                                      expression:
                                                                        "tipoAnalisePlanilha"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Definir limites e Confrontações"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    2653631847
                                                  )
                                                })
                                              : _vm._e(),
                                            !_vm.isReurb
                                              ? _c("app-documentos", {
                                                  attrs: {
                                                    aba: "Georreferenciamento",
                                                    isAnalise: true,
                                                    idUploadDocumento:
                                                      "documentoGeorreferenciamento",
                                                    titulo:
                                                      "Georreferenciamento",
                                                    maxSize: 25000,
                                                    "valid-extensions":
                                                      _vm.extensoes,
                                                    documentos:
                                                      _vm.documentosGeomensor,
                                                    tiposDocumentos:
                                                      _vm.tipoDocumentosGeomensor,
                                                    tiposDocumentosObrigatorios:
                                                      _vm.tipoDocumentosGeomensorObrigatorios,
                                                    pecasTecnicas: true,
                                                    pecasTecnicasSalvas:
                                                      _vm.pecasTecnicas,
                                                    mensagemErroFilaPlantaMemorial:
                                                      _vm.mensagemErroPlantaMemorial,
                                                    observer: this.$refs
                                                      .validation,
                                                    isRequired: _vm.showRequired
                                                  },
                                                  on: {
                                                    mudaTipo: _vm.mudaTipo,
                                                    setDadosPlanilha:
                                                      _vm.setDadosPlanilha,
                                                    removedDoc: _vm.removeFile,
                                                    addedDoc: _vm.addedDoc
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm.showMapa || _vm.isReurb
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "extra-margin-top-bottom"
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules:
                                                          _vm.required.rules,
                                                        name:
                                                          "Georreferenciamento/Geometria"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "mapa-analise-geomensor",
                                                                  {
                                                                    attrs: {
                                                                      localizacoes:
                                                                        _vm
                                                                          .dadosCadastros
                                                                          .despacho
                                                                          .localizacoes,
                                                                      tipoCadastro:
                                                                        _vm
                                                                          .processo
                                                                          .tipo
                                                                          .codigo,
                                                                      name:
                                                                        "Geometria",
                                                                      idMapa:
                                                                        "mapaAnaliseGeomensor",
                                                                      errors: errors,
                                                                      addOrtoFotos: true
                                                                    },
                                                                    on: {
                                                                      shapefileUploaded:
                                                                        _vm.setShapefile,
                                                                      shapefileRemoved:
                                                                        _vm.removeShapefile
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .dadosCadastros
                                                                          .despacho
                                                                          .localizacoes,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .dadosCadastros
                                                                            .despacho,
                                                                          "localizacoes",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "dadosCadastros.despacho.localizacoes"
                                                                    }
                                                                  }
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "help erro"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        false,
                                                        2345396818
                                                      )
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.isFiscalizador()
                                      ? _c(
                                          "div",
                                          [
                                            _c("app-documentos", {
                                              attrs: {
                                                isAnalise: true,
                                                idUploadDocumento:
                                                  "documentoFiscalizacao",
                                                titulo:
                                                  "Relatório de Fiscalização",
                                                maxSize: 25000,
                                                "valid-extensions": [
                                                  "png",
                                                  "jpg",
                                                  "jpeg",
                                                  "pdf",
                                                  "doc",
                                                  "docx"
                                                ],
                                                documentos:
                                                  _vm.documentosFiscalizador,
                                                tiposDocumentos:
                                                  _vm.tipoDocumentosFiscalizador,
                                                tiposDocumentosObrigatorios:
                                                  _vm.tipoDocumentosFiscalizador,
                                                pecasTecnicas: true,
                                                removeOutros: true,
                                                aba: "Fiscalizacao",
                                                observer: this.$refs.validation,
                                                isRequired: _vm.showRequired
                                              },
                                              on: { removedDoc: _vm.removeFile }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                : _vm._e(),
                              _vm.isVistoriador()
                                ? [
                                    [
                                      _c("app-documentos", {
                                        attrs: {
                                          isAnalise: true,
                                          idUploadDocumento:
                                            "documentoVistoria",
                                          titulo: "Laudo de Vistoria",
                                          maxSize: 25000,
                                          "valid-extensions": [
                                            "png",
                                            "jpg",
                                            "jpeg",
                                            "pdf",
                                            "doc",
                                            "docx"
                                          ],
                                          documentos: _vm.documentosVistoriador,
                                          tiposDocumentos:
                                            _vm.tipoDocumentosVistoriador,
                                          tiposDocumentosObrigatorios:
                                            _vm.tipoDocumentosVistoriador,
                                          pecasTecnicas: true,
                                          removeOutros: true,
                                          aba: "Vistoria",
                                          observer: this.$refs.validation,
                                          isRequired: _vm.showRequired
                                        },
                                        on: { removedDoc: _vm.removeFile }
                                      })
                                    ]
                                  ]
                                : _vm._e(),
                              _vm.isAdministrativo()
                                ? [
                                    [
                                      _c("app-documentos", {
                                        attrs: {
                                          isAnalise: true,
                                          idUploadDocumento:
                                            "documentoAdministrativo",
                                          titulo: "Laudo Administrativo",
                                          maxSize: 25000,
                                          "valid-extensions": [
                                            "png",
                                            "jpg",
                                            "jpeg",
                                            "pdf",
                                            "doc",
                                            "docx"
                                          ],
                                          documentos:
                                            _vm.documentosAdministrativo,
                                          tiposDocumentos:
                                            _vm.tipoDocumentosAdministrativo,
                                          tiposDocumentosObrigatorios:
                                            _vm.tipoDocumentosAdministrativo,
                                          pecasTecnicas: true,
                                          removeOutros: true,
                                          aba: "Administrativo",
                                          observer: this.$refs.validation
                                        },
                                        on: { removedDoc: _vm.removeFile }
                                      }),
                                      _c("app-divider", {
                                        staticClass: "margin-top-bottom",
                                        attrs: {
                                          label: "Beneficiários",
                                          showBorder: false
                                        }
                                      }),
                                      _vm.processo
                                        ? _c("beneficiarios", {
                                            attrs: {
                                              modulo: "analise",
                                              scope: "beneficiarios",
                                              observer: this.$refs.validation,
                                              processo: _vm.processo
                                            },
                                            on: {
                                              updateBeneficiariosLista:
                                                _vm.updateBeneficiariosLista,
                                              changedBeneficiarios: function(
                                                $event
                                              ) {
                                                _vm.beneficiariosChanged = true
                                              },
                                              hasBeneficiarios:
                                                _vm.hasBeneficiarios
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                    ]
                  )
                : _vm._e(),
              _vm.showDespachoTecnicoCampo
                ? _c(
                    "el-card",
                    {
                      staticClass: "card-collapse",
                      attrs: { shadow: "hover" }
                    },
                    [
                      (_vm.dadosCadastros.despacho.acao &&
                        _vm.dadosCadastros.despacho.acao.includes(
                          "ARQUIVAMENTO"
                        )) ||
                      _vm.isBa
                        ? _c(
                            "div",
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "flex-despacho" },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "label" },
                                                [
                                                  _vm._v("Despacho"),
                                                  _c(
                                                    "span",
                                                    { staticClass: "required" },
                                                    [_vm._v("  *  ")]
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "primary" },
                                                  on: {
                                                    click: _vm.openModalDespacho
                                                  }
                                                },
                                                [
                                                  _vm._v("Modelo  "),
                                                  _c("div", {
                                                    staticClass: "fa fa-file"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c("app-editor-texto", {
                                            ref: "editorTexto",
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            on: {
                                              onTextChange: _vm.onTextChange
                                            },
                                            model: {
                                              value:
                                                _vm.dadosCadastros.despacho
                                                  .textoDespacho,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosCadastros.despacho,
                                                  "textoDespacho",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "dadosCadastros.despacho.textoDespacho"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                          _c("app-anexo", {
                                            attrs: {
                                              id: "upload-anexo-despacho",
                                              files: _vm.anexos,
                                              tipoExibir: "ANEXO_ANALISE"
                                            },
                                            on: {
                                              uploadFile: _vm.uploadFile,
                                              removeFile: _vm.removeFile,
                                              downloadDocumentoCadastro:
                                                _vm.downloadDocumentoCadastro
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3022066092
                                )
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isBa
                        ? _c("app-radios-tramitacao", {
                            attrs: {
                              radios: _vm.acoesRadio,
                              isDecisao: _vm.isDecisao,
                              isEsconderEncaminhamento:
                                _vm.dadosCadastros.encaminhamento,
                              radioInicial: _vm.dadosCadastros.despacho.acao
                            },
                            on: { changeRadio: _vm.changeRadio }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c("app-buttons-cadastro", {
                attrs: {
                  isUltimoPasso: _vm.isUltimoPasso,
                  isPrimeiroPasso: !_vm.isUltimoPasso,
                  showButtonSalvar: true,
                  showButtonProximo: true
                },
                on: {
                  proximo: _vm.proximo,
                  finalizar: _vm.finalizar,
                  cancelar: _vm.cancelar,
                  salvar: _vm.salvar,
                  voltar: _vm.voltar
                }
              }),
              _c(
                "div",
                [
                  _vm.showModalDespacho
                    ? _c("app-modal-selecionar-modelo-notificacao", {
                        attrs: {
                          tiposModelo: _vm.tiposModelo,
                          titulo: _vm.tituloModalModelo,
                          idProcesso: _vm.processo.id,
                          showModal: _vm.showModalDespacho
                        },
                        on: {
                          closeModal: _vm.fecharModalDespacho,
                          setTextoDespacho: _vm.setTextoDespacho
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a2d3d2da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2d3d2da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/AnalisarValidarSubProcesso.vue
// module id = null
// module chunks = 